module.exports = __webpack_public_path__ + "img/gh.0e21c55a.png";